// extracted by mini-css-extract-plugin
export default {"root":"requirement_option-module___root___c41b4e9e","input":"requirement_option-module___input___f4fdab27"};